module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.89889688147bd7575d63.svg";


//////////////////
// WEBPACK FOOTER
// F:/Home/Locker/About-me/about-me1/src/assets/fonts/glyphicons-halflings-regular.svg
// module id = ../../../../../src/assets/fonts/glyphicons-halflings-regular.svg
// module chunks = styles